import React, { useEffect } from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { LanguageProvider } from '@/i18n/LanguageContext';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import Home from '@/pages/Home';
import ChiSiamo from '@/pages/ChiSiamo';
import CosaOffriamo from '@/pages/CosaOffriamo';
import ComeFunziona from '@/pages/ComeFunziona';
import SeiUnProprietario from '@/pages/SeiUnProprietario';
import Strutture from '@/pages/Strutture';
import ValutazioneGratuita from '@/pages/ValutazioneGratuita';
import GuestRegistration from '@/pages/GuestRegistration';
import TaxCalculation from '@/pages/TaxCalculation';
import GuestPayment from '@/pages/GuestPayment';
import GuestConfirmation from '@/pages/GuestConfirmation';
import ApartmentInstructions from '@/pages/ApartmentInstructions';
import AdminExport from '@/pages/AdminExport';
import CleaningPortal from '@/pages/cleaning/CleaningPortal';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

// Hidden guest pages don't show Navbar/Footer
const GUEST_PATHS = ['/suite', '/bellavista', '/oasis', '/crisalide', '/emerald', '/admin/export', '/cleaning'];

function AppLayout() {
  const { pathname } = useLocation();
  const isGuestPage = GUEST_PATHS.some(p => pathname.startsWith(p));

  return (
    <>
      <ScrollToTop />
      {!isGuestPage && <Navbar />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/chi-siamo" element={<ChiSiamo />} />
        <Route path="/cosa-offriamo" element={<CosaOffriamo />} />
        <Route path="/come-funziona" element={<ComeFunziona />} />
        <Route path="/sei-un-proprietario" element={<SeiUnProprietario />} />
        <Route path="/strutture" element={<Strutture />} />
        <Route path="/valutazione-gratuita" element={<ValutazioneGratuita />} />
        {/* Cleaning portal (private) */}
        <Route path="/cleaning" element={<CleaningPortal />} />
        {/* Guest registration pages (hidden, no navigation) */}
        <Route path="/:apartment" element={<GuestRegistration />} />
        <Route path="/:apartment/tax" element={<TaxCalculation />} />
        <Route path="/:apartment/payment" element={<GuestPayment />} />
        <Route path="/:apartment/confirmation" element={<GuestConfirmation />} />
        <Route path="/:apartment/instructions" element={<ApartmentInstructions />} />
        {/* Admin */}
        <Route path="/admin/export" element={<AdminExport />} />
      </Routes>
      {!isGuestPage && <Footer />}
    </>
  );
}

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <BrowserRouter>
          <AppLayout />
        </BrowserRouter>
      </div>
    </LanguageProvider>
  );
}

export default App;